/**
 * 파일명 : com010101p.tsx
 * 설명 : 참조자 조회
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 */

/************************************************
 * Import 영역  
 ************************************************/
/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0101p2Action } from '../../../redux/slice/com/com0101p2_slice';
import { IInquiryCndsState, ITargetItemState, IUserItemState, IDeptTreeState } from '../../../redux/models/com/com0101p2_model';

/* AntD */
import { Layout, Row, Col, Space, Button, Tree, Table, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { GetComponentProps } from 'rc-table/lib/interface';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';

/************************************************
 * 전역변수 선언영억
 ************************************************/
const Com0101p2 = (props:any) => {
	/** State / Ref / Reducer 선언 **/
    const dispatch = useAppDispatch();
    const deptTree   = useAppSelector((state) => state.Com0101p2.deptTree);
    const treeKey    = useAppSelector((state) => state.Com0101p2.treeKey);
    const maxLvlCd   = useAppSelector((state) => state.Com0101p2.maxLvlCd);
    const targetList = useAppSelector((state) => state.Com0101p2.targetList);
    const userList   = useAppSelector((state) => state.Com0101p2.userList);

    let myDeptNode:IDeptTreeState;
    const nodeRefs = React.useRef<Record<string, HTMLSpanElement | null>>({});


    /************************************************
     * 화면 초기화 이벤트
     ************************************************/
    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     **/
    React.useEffect(() => {
        dispatch(Com0101p2Action.setTargetList([]));

        if (!deptTree || deptTree.length < 1) {
            // 입력파라미터
            const requestData = {};
    
            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd : 'TRCOMR0003',
                success : (responseData:any) => {
                    dispatch(Com0101p2Action.setDeptTree(responseData.deptTree));
                    dispatch(Com0101p2Action.setMaxLvlCd(responseData.lastLvl));
                },
            });
        };

    }, []);


    const findNodeMyDept = (treeData:IDeptTreeState[]) => {
        for (const node of treeData) {
            if (node.key === common.getDeptCd()) return node;
      
            if (node.children) {
                const found:IDeptTreeState = findNodeMyDept(node.children);

                if (found) return found;
            }
        }
        return null;
    };

    React.useEffect(() => {
        if (deptTree && deptTree.length > 0 && (!myDeptNode || Object.keys(myDeptNode).length < 1)) {
            myDeptNode = findNodeMyDept(deptTree);

            if (myDeptNode) {
                setDeptUsers(myDeptNode.key);
            }
        }
    }, [deptTree]);


    /************************************************
     * 이벤트 함수 영역
     ************************************************/
    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnClose': {
                props.cancel();
                break;
            }
            case 'btnOk': {
                props.accept(targetList.filter((item:ITargetItemState) => {
                    return item.refEmpNo !== common.getEmpNo();
                }));
                break;
            }
            default:
        }
    };

    /**
     * 기능 : Tree 선택 이벤트 선언
     * param : 
     */
    /**
     * 기능 : Tree 선택 이벤트 선언
     * param : 
     */
     const onSelect = (_keys:any, event:any) => {
        setDeptUsers(event.node.key);
    };

    const setDeptUsers = (deptCd:string) => {
        const requestData:IInquiryCndsState = {
            deptCd : deptCd,
            userStCd : 'A',
        };
        
        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd : 'TRUSRR0003',
            success : (responseData:any) => {
                dispatch(Com0101p2Action.setUserList(responseData.userList));
                dispatch(Com0101p2Action.setTreeKey(deptCd));

                if (deptCd && nodeRefs.current[deptCd]) {
                    nodeRefs.current[deptCd].scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            },
        });
    }

    /**
     * 기능 : onRow
     */
    const onUserRow: GetComponentProps<IUserItemState> = (record:IUserItemState, _rowIndex) => ({
        onClick: (_event:any) => {
            const itemTarget:ITargetItemState = { 
                           dnm        : '참조자'
                         , ord        : record.key + 1
                         , refEmpNo   : record.empNo
                         , refUserNm  : record.userNm 
                         , refOrd     : targetList.length
                         , postNm     : record.postNm
                         , dutyNm     : record.dutyNm
                         , deptNm     : record.deptNm
                         , chkYn      : 'N'
                         , refStNm    : '안읽음'
            };

            if (record.empNo !== common.getEmpNo()) {
                dispatch(Com0101p2Action.addTargetList(itemTarget));
            }
        },
    });
    const onTargetRow: GetComponentProps<ITargetItemState> = (record:ITargetItemState, _rowIndex) => ({
        onClick: (event:any) => {
            const target = event.target as HTMLElement;
            const iconName = target.getAttribute('data-icon');

            if (iconName === 'delete') {
                const arrFilterd:ITargetItemState[] = targetList.filter((item:ITargetItemState) => {
                    return item.refEmpNo !== record.refEmpNo;
                });
    
                dispatch(Com0101p2Action.setTargetList(arrFilterd));
            }
        },
    });

    /************************************************
     * 개발자함수 영역
     ************************************************/


    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */


     /* Render 변수 선언영역 */
     /* AntD */
     const { Content } = Layout;
     const { Text }    = Typography;

    /* Table Columns */
    const columnsUsers = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>부서</div>,
                dataIndex: 'deptNm',
                key: 'deptNm',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>직책</div>,
                dataIndex: 'dutyNm',
                key: 'dutyNm',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>직위</div>,
                dataIndex: 'postNm',
                key: 'postNm',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>이름</div>,
                dataIndex: 'userNm',
                key: 'userNm',
                align: 'center',
                width: '10%',
            }];
            return arr;
    }, []);

    const columnsTarget = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>구분</div>,
                dataIndex: 'dnm',
                key: 'dnm',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>이름</div>,
                dataIndex: 'refUserNm',
                key: 'refUserNm',
                align: 'center',
                width: '10%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>삭제</div>,
                key: 'action',
                render: (_text:string, _:ITargetItemState) => (
                    <Button
                        id='btn_showDetail'
                        name='btn_showDetail'
                        className='link-button'
                        size='small'
                        icon={<DeleteOutlined style={{color:'red'}}/>}
                    />
                ),
                align: 'center',
                width: '5%',
            }];
            return arr;
    }, []);


    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Row>
                    <Col style={{width : 7 * parseInt(maxLvlCd) + '%', height : '500px'}}>
                        {deptTree && deptTree.length > 0 ?
                        <Tree
                            showLine
                            prefixCls='dept-tree'
                            className='dept-tree'
                            defaultExpandAll={true}
                            onSelect={onSelect}
                            treeData={deptTree}
                            selectedKeys={[treeKey]}
                            style={{maxHeight : '500px', overflowY : 'auto'}}
                            titleRender={(nodeData) => (
                                <span ref={(el) => {
                                    if (el) {
                                        nodeRefs.current[nodeData.key] = el;
                                    }
                                }}>
                                    {nodeData.title}
                                </span>
                              )}
                        /> : null}
                    </Col>
                    <Col style={{ width : 100 - 7 * parseInt(maxLvlCd) + '%', height : '500px'}}>
                        <Row>
                            <Space>
                                <img className='title-icon' alt='' />
                                <Text strong>사용자목록</Text>
                            </Space>
                            <Col>
                                <Table
                                    dataSource={userList}
                                    key='empNo'
                                    columns={columnsUsers()}
                                    size='small'
                                    style={{width:'100%'}}
                                    scroll={{y:180}}
                                    pagination={false}
                                    onRow={onUserRow}
                                />
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Space>
                                <img className='title-icon' alt='' />
                                <Text strong>참조자목록</Text>
                            </Space>
                            <Col>
                                <Table
                                    dataSource={targetList}
                                    key='refEmpNo'
                                    columns={columnsTarget()}
                                    size='small'
                                    style={{width:'100%'}}
                                    scroll={{y:180}}
                                    pagination={false}
                                    onRow={onTargetRow}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row justify='center'>
                    <Col>
                        <Space direction='vertical'>
                            <Row justify='space-around' style={{ marginTop: 20 }}>
                                <Space size='small'>
                                    <Button
                                        name='btnClose'
                                        className='background-color-default-button'
                                        onClick={onClick}
                                    >
                                        닫기
                                    </Button>
                                    <Button
                                        name='btnOk'
                                        className='background-color-primary-button'
                                        onClick={onClick}
                                    >
                                        확인
                                    </Button>
                                </Space>
                            </Row>
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0101p2;